import { createAction } from "redux-starter-kit";
import { CLOSE_SEND_NOA } from "../types";

const openSendNOA = () => createAction(CLOSE_SEND_NOA)({});

export default openSendNOA;
